module.exports = __webpack_public_path__ + "static/media/logo-text-handritin-til-barnanna-white.52146dd4.svg";